import Preact, { h, Component } from 'preact'
import LogoInverse from '../assets/logo-inverse'
import Icon from '../assets'
import UserAvatar from '../User/UserAvatar'
import Dropdown from '../dropdown'

type Link = {
  label: string,
  route: string
}

type Name = string

type User = {
  id: number,
  name: string,
  avatar: string
}

type CustomFilters = []

type SidebarItem = {
  name: Name,
  label: string,
  links: { [index: string ] : any },
  iconName: any
}

interface Props {
  sidebar: SidebarItem[],
  customFilters: CustomFilters,
  privateMessagesUnreadCount: number,
  customerName: string,
  user: User
}

interface State {
  activeItemName: Name | null,
  isOpen: boolean,
  isOverlay: boolean,
}

const ITEMS_WITH_NO_SUBMENU = ['users', 'privateMessages', 'openCommunity']

class ControlSideMenu extends Component<Props, State> {
  private arrowElement: HTMLInputElement | null = null
  private subMenuElement: HTMLInputElement | null = null
  private mainContainerElement: HTMLElement | null = null
  private timer: number | undefined

  constructor ({ sidebar, customFilters }: Props) {
    super()

    this.state = {
      activeItemName: null,
      isOpen: true,
      isOverlay: false,
    }

    sidebar.map((item: SidebarItem) => {
      if (isItemActive(item, customFilters)) {
        const isOpenSubmenu = !ITEMS_WITH_NO_SUBMENU.includes(item.name)
        this.setState({
          activeItemName: item.name,
          isOpen: isOpenSubmenu
        })
      }
    })

    this.arrowElement = Preact.createRef()
    this.subMenuElement = Preact.createRef()
  }

  componentDidMount(): void {
    const {isOpen, activeItemName } = this.state
    this.mainContainerElement = document.querySelector('.main-control-side-menu') || document.querySelector('.control-side-menu-content')

    if(!isOpen || activeItemName === null) {
      this.mainContainerElement!.style.marginLeft = this.isProfilePage() || this.isProfileFieldPage() ? '40px' : '0';
    }

    window.addEventListener('hashchange', () => this.forceUpdate())
  }

  toggleMenuItem (event: any, item: SidebarItem) {
    event && event.preventDefault()
    this.setState({
      activeItemName: item.name,
      isOpen: true
    }, () => this.openSidebar())
  }

  onArrowHoverLeave () {
    const { isOpen } = this.state
    const isSubMenuHover = this.subMenuElement && this.subMenuElement.matches(':hover')

    if (isOpen || !isSubMenuHover) {
      return
    }

    this.setState({ isOverlay: true })
  }

  onSubmenuHover () {
    const { isOpen } = this.state
    const isArrowHover = this.arrowElement && this.arrowElement.matches(':hover')

    if (isOpen || isArrowHover) {
      return
    }

    this.timer = window.setTimeout(() => {
      this.setState({ isOverlay: true })
    }, 500)
  }

  isTopicOverview = () => this.mainContainerElement?.getAttribute('id') ==='content'

  isProfilePage = () => window.location.pathname.includes('member/profile')

  isProfileFieldPage = () => window.location.pathname.includes('settings/profilefield')

  openSidebar() {
    this.mainContainerElement!.style.marginLeft = this.state.isOverlay ? this.isTopicOverview() ? '40px': '16px' : this.isTopicOverview() ? '280px' : '240px'
  }

  closeSidebar() {
    this.mainContainerElement!.style.marginLeft = this.isTopicOverview() ? '40px': '16px'
  }

  render ({ sidebar, customFilters, privateMessagesUnreadCount, customerName, user }: Props, { activeItemName, isOpen, isOverlay }: State) {
    return (
      <div class='control-side-menu-wrapper'>
          <div class='control-side-menu'>
              <div className='control-side-menu__menu-item-logo'>
                <LogoInverse />
                <div className='control-side-menu__menu-item-label'>Proudly working for {customerName} 💙</div>
              </div>
              {sidebar.map((item: SidebarItem) => {
                const isActive = isItemActive(item, customFilters)
                const isFirstItemOfSecondaryList = item.name === 'openCommunity'
                return ITEMS_WITH_NO_SUBMENU.includes(item.name) ?
                    item.name === 'privateMessages' ?
                      <a href={item.links[0].route}>
                        <MenuItem isActive={isActive} item={item}>
                          { privateMessagesUnreadCount > 0 ?
                              <div class='control-side-menu__menu-item--pm-count'>
                                {privateMessagesUnreadCount < 100 ? privateMessagesUnreadCount : <span class='morePms'>•••</span>}
                              </div> : undefined }
                        </MenuItem>
                      </a>
                    : <a class={`${isFirstItemOfSecondaryList ? 'push-up': ''}`} href={item.links[0].route} target={item.name === 'openCommunity' ? '__blank': undefined}>
                      <MenuItem isActive={isActive} item={item} />
                    </a>
                : <MenuItem isActive={isActive} item={item} onClick={(event: any) => this.toggleMenuItem(event, item)} />
              })
              }
            <div class='control-side-menu__menu-item-avatar'>
              <Dropdown class='' trigger={<UserAvatar user={{ ...user }} disableLink />}>
                <div class='control-side-menu__menu-user'>
                  <a href='/member/logout'><Icon icon='logOut' />Log out</a>
                </div>
              </Dropdown>
            </div>
          </div>
        <div
          class={`control-side-menu__details${!isOpen ? ' collapsed' : ''}${isOverlay ? ' overlay' : ''}`}
          ref={subMenu => { this.subMenuElement = subMenu }}
          onMouseEnter={() => this.onSubmenuHover()}
          onMouseLeave={() => {
            if(this.timer) window.clearTimeout(this.timer)
            !isOpen && this.setState({ isOverlay: false }, () => this.closeSidebar())
          }}
          style={{'display': activeItemName && !ITEMS_WITH_NO_SUBMENU.includes(activeItemName) ? 'flex' : 'none'}}
        >
          {sidebar.map((item: SidebarItem) => {
            if (activeItemName === item.name) {
              const wrapperProps: { [prop: string]: any } = {
                class: 'control-side-menu__items-wrapper'
              }
              if(!isOpen && !isOverlay) wrapperProps.style = { 'visibility': 'hidden'}

              return <div {...wrapperProps} >
                <div class='control-side-menu__details-heading'>{item.label}</div>
                { !Array.isArray(item.links) ?
                    <div>
                      <GroupedItemList item={item} />
                      { item.name === 'moderation' && customFilters.length > 0 ? <CustomFiltersList customFilters={customFilters} /> : null}
                    </div>
                  : <ItemList item={item} />
                }
              </div>
            }
            return null
          })
          }
          <div
            class='control-side-menu__details-arrow'
            ref={arrow => { this.arrowElement = arrow }}
            onClick={() => this.setState({ isOpen: !isOpen, isOverlay: false }, () => isOpen ? this.closeSidebar() : this.openSidebar())}
            onMouseLeave={() => this.onArrowHoverLeave()}
          >
            <Icon icon='arrowRoundedLeft' />
          </div>
        </div>
      </div>
    )
  }
}

export default ControlSideMenu

const isItemActive = (item: SidebarItem, customFilters: CustomFilters) => {
  if(Array.isArray(item.links)) {
    return item.links.some(isActiveLink)
  }

  const subLinks = Object.keys(item.links)
      .map((groupName: string) => item.links[groupName])
      // flat the array
      .reduce((acc, val) => acc.concat(val), [])

  return subLinks.some(isActiveLink) || (item.name === 'moderation' && customFilters && customFilters.some(isActiveLink))
}

const isActiveLink = (link: Link) => {
  const index = link.route.indexOf('#')

  if(link.label === 'Overview') {
    return window.location.pathname.includes(link.route)
  }

  if (index > 0) {
    return window.location.pathname + window.location.search + window.location.hash === link.route
  }

  return window.location.pathname + window.location.search === link.route
}

const renderLink = (isCustomFilter: boolean) => {
  return (link: Link) => {
    const isActive = isActiveLink(link)
    return <li
      class={'navigation-menu__item--' + link.label.toLowerCase().replace(/ /g, '_') + (isCustomFilter ? ' custom qa-custom' : '')}>
      <a class={isActive ? 'active' : undefined} href={link.route}>{link.label}</a>
    </li>
  }
}

const ItemList = ({ item } : { item: SidebarItem }) => {
  return <ul>{item.links.map(renderLink(false))}</ul>
}

const GroupedItemList = ({ item } : { item: SidebarItem }) => {
  return <div>{Object.keys(item.links).map((groupName: string) => {
    const subLinks = item.links[groupName]
    return <div>
      <div class='control-side-menu__details-sub-heading'>{groupName}</div>
      <ul>
        {subLinks.map(renderLink(false))}
      </ul>
    </div>
  })}</div>
}

const CustomFiltersList = ({ customFilters } : { customFilters: CustomFilters }) => {
    return <div>
    <div className = 'control-side-menu__details-sub-heading' >custom filters</div>
      <ul>{customFilters.map(renderLink(true))}</ul>
  </div>
}

const MenuItem = ({ item, isActive, onClick, children }: { item: { label: string, iconName: any }, isActive: boolean, onClick?: (event: any) => void, children?: JSX.Element }) => {
  const props = {
    class: `control-side-menu__menu-item${isActive ? ' active' : ''}`,
    onClick: onClick
  }

  return <div {...props}>
    <Icon icon={item.iconName} width={20} height={20} color={isActive ? ' #FFFFFF' : '#D5D6D6'}/>
    <div className='control-side-menu__menu-item-label'>{item.label}</div>
    {children}
  </div>
}
